export default "__VITE_ASSET__cf89c355__"